import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme =>
  createStyles({
    paper: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 962,
      background: theme.colors.white,
      boxShadow: theme.boxShadows.greyLight,
      borderRadius: 16,
      overflow: 'hidden',
      height: '100%',
      maxHeight: 740,
    },
  })
)
